import { render, staticRenderFns } from "./SmsPendingMessages.vue?vue&type=template&id=15f9a3d8&"
import script from "./SmsPendingMessages.vue?vue&type=script&lang=js&"
export * from "./SmsPendingMessages.vue?vue&type=script&lang=js&"
import style0 from "./SmsPendingMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports